var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.4162V22.0001H4.58397L18.1097 8.47435L13.5257 3.89038L0 17.4162Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6425 3.21181L18.7882 0.357549C18.3115 -0.119183 17.5352 -0.119183 17.0585 0.357549L14.8215 2.59452L19.4055 7.17849L21.6425 4.94152C22.1193 4.46478 22.1193 3.68855 21.6425 3.21181Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonEdit);
export default __webpack_public_path__ + "static/media/person-edit.0eea13e6235f1da0114ec4ab848e7061.svg";
export { ForwardRef as ReactComponent };